import { useCallback } from "react";
import { useAuthenticationContext } from "../../context/authenticationContext/authenticationContext";
import { useAdminController } from "../useAdminController/useAdminController";

export interface ISBAutoDeleteUpdateResult {
  name: string;
  autoDeleteOnIdle: string;
}

export const useSBAutoDeleteUpdater = (): [
  ISBAutoDeleteUpdateResult | undefined,
  boolean,
  Error | undefined,
  (
    topic: string,
    subscription: string,
    queue: string,
    idleDays: number
  ) => Promise<ISBAutoDeleteUpdateResult>
] => {
  const { user } = useAuthenticationContext();
  const { patch, response, loading, error } =
    useAdminController<ISBAutoDeleteUpdateResult>(user!, false);

  const update = useCallback(
    async (
      topic: string,
      subscription: string,
      queue: string,
      idleDays: number
    ) => {
      var endpoint = `autoDeleteOnIdle?idleDays=${idleDays}`;
      if (subscription !== "") {
        endpoint += `&topic=${topic}&subscription=${subscription}`;
      } else if (topic !== "") {
        endpoint += `&topic=${topic}`;
      } else {
        endpoint += `&queue=${queue}`;
      }

      let result = await patch(endpoint);
      return result;
    },
    [patch]
  );

  return [response.data, loading, error, update];
};
